import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { pointerEventsStyles, theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingSecondaryNav = (props: Props) => {
  const { children } = props;

  return <View style={[styles.container, pointerEventsStyles['box-none']]}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexShrink: 1,
    alignItems: 'center',
    gap: theme.spacing['3'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
